<template>
  <div class="flex flex-grow">
    <ul class="nav nav-pills hidden relative xl:order-first xl:flex xl:flex-col flex-shrink-0 w-72 pr-4 pb-6" v-if="showNav">
      <li 
        v-for="(tab, tabId) in tabs" 
        :key="tabId"
        class="nav-item"
        :class="{ 'active': tab.show }" 
        :id="tabId + '-tab'"
      >
        <a 
          :href="'#' + tabId" 
          class="nav-link w-full flex items-center justify-between"
          :class="{ 'text-red-600' : errors[tabId] && errors[tabId].numOfErrors}"
          @click.stop="setActive(tab)"
        >
          {{ tab.title }}
          <span
            v-if="errors[tabId] && errors[tabId].numOfErrors"
            class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-600 text-xs text-white"
          >
            {{ errors[tabId].numOfErrors }}
          </span>
        </a>
      </li>
    </ul>
    <div class="tab-content flex-1 focus:outline-none xl:order-last min-w-0">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { reactive, provide } from 'vue'
let tabsCnt = 0

export default {
  props: {
    showNav: {
      type: Boolean,
      default: true
    }
  },
  setup () {
    const tabs = reactive({})
    let activeTabId = null
    let activeTabHash = null

    if (window?.location?.hash) {
      activeTabHash = window.location.hash.substring(1)
    }

    provide('addTab', (title, active, id = null) => {
      const tab = {
        title,
        id: id || 'tab_' + (tabsCnt++),
        show: active
      }

      if ((activeTabHash === tab.id || active) && activeTabId) {
        tabs[activeTabId].show = false
      }

      if (active && (activeTabId === null || activeTabId !== activeTabHash)) {
        activeTabId = tab.id
      } else if (activeTabHash === tab.id) {
        tab.show = true
        activeTabId = tab.id
      } else {
        tab.show = false
      }

      tabs[tab.id] = tab
      return tabs[tab.id]
    })

    const setActive = (tab) => {
      if (activeTabId) {
        tabs[activeTabId].show = false
      }

      activeTabId = tab.id
      tab.show = true
    }

    return {
      tabs,
      setActive,
    }
  },
  computed: {
    errors() {
      const results = {}
      Object.keys(this.$formErrors).forEach((formKey) => {
        const formField = this.$controls[formKey]
        
        if (!formField.attrs || !formField.attrs["data-tab-id"]) {
          return
        }

        const keys = formField.attrs["data-tab-id"].split(',')
        keys.forEach((key) => {
          if (!results[key]) {
            results[key] = {
              numOfErrors: 0,
              errors: [],
            }
          }

          console.log('this.$formErrors[formKey]', formKey, this.$formErrors[formKey], key)
          if (this.$formErrors[formKey]) {
            ++results[key].numOfErrors
            results[key].errors.push(this.$formErrors[formKey])
          }
        })
      })
      return results
    }
  }
}
</script>
